import { IdentificationRequestStatus } from '@models/IdentificationRequests.model';
import { useMemo } from 'react';

import {
  RequestStatusWrapper,
  RequestStatusBadge,
  RequestStatusTag,
} from './IdentificationRequestsStatus.styles';

type StatusProps = {
  status: IdentificationRequestStatus;
};

const IdentificationRequestsStatus = ({ status }: StatusProps) => {
  const tag = useMemo((): string => {
    switch (status) {
      case 'confirm_product':
        return 'Confirm Product';
      case 'information_needed':
        return 'Information Needed';
      case 'resolved':
        return 'Resolved';
      case 'closed':
        return 'Closed';
      default:
        return 'Open';
    }
  }, [status]);

  return (
    <RequestStatusWrapper>
      <RequestStatusBadge $status={status} />

      <RequestStatusTag $status={status}>{tag}</RequestStatusTag>
    </RequestStatusWrapper>
  );
};

export { IdentificationRequestsStatus };
